import { createContext } from "react";
import { ApolloError } from "@apollo/client";
import { DateInPeriod, Periodicity } from "./types";
import {
  ActivityFragment,
  EventFragment,
} from "../../../__generated__/graphql";

interface CalendarContextType {
  selectedEvent: EventFragment | null;
  setSelectedEvent: (event: EventFragment | null) => void;
  currentDate: Date;
  events: EventFragment[] | undefined;
  activities: ActivityFragment[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  onPeriodChange: (direction: "left" | "right" | "today") => void;
  periodicity: Periodicity;
  setPeriodicity: (periodicity: Periodicity) => void;
  datesInPeriod: DateInPeriod[];
  periodDescription: string;
}

export const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined
);
